/* src/app/private/components/admission/delete-admission/delete-admission.component.scss */
/*# sourceMappingURL=delete-admission.component.css.map */
